import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Footer from './Footer';
import Home from './Home';
import PageNotFound from './PageNotFound';
import Navbar from '../navbar/index';
import Contact from '../contact/Contact';
import '../../assets/scss/app.scss';
import { Box } from '@chakra-ui/layout';
import { useColorModeValue } from '@chakra-ui/color-mode';
import Projects from '../projects/index';
import ReactGA from 'react-ga';


const TRACKING_ID = process.env.REACT_APP_TRACKING_ID; 

ReactGA.initialize(TRACKING_ID);

function App() {
  const bg = useColorModeValue('gray.200', 'black');
  const color = useColorModeValue('gray.800', 'white');
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <div className="App">
      <Box bg={bg} color={color}>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/projects" element={<Projects/>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <Footer />
      </Box>
    </div>
  );
}

export default App;
